import { GET_OFFERS_START } from "../../types";

export const offers = (payload) => ({
  type: GET_OFFERS_START,
  payload,
});
